import * as React from "react";
import GroupList from "./group-list";

class Index extends React.Component<{}, {}> {
    render = () => {
        return (
            <GroupList />
        );
    }
}

export default Index;